import React from 'react';
import { Slide1Cover, Slide3Founders, Slide4WhatsBuilt, Slide5DesignArsenal } from './components/Slides1To5';
import { Slide9CompetitiveAdvantages, Slide10TeamStructure } from './components/Slides6To10';
import { Slide11StrategicLocation } from './components/Slides11To15';
export function App() {
  return <main className="bg-white min-h-screen w-full selection:bg-black selection:text-white" data-id="element-0">
      <Slide1Cover data-id="element-1" />
      <Slide3Founders data-id="element-2" />
      <Slide4WhatsBuilt data-id="element-3" />
      <Slide5DesignArsenal data-id="element-4" />
      <Slide9CompetitiveAdvantages data-id="element-5" />
      <Slide10TeamStructure data-id="element-6" />
      <Slide11StrategicLocation data-id="element-7" />
    </main>;
}